<template>
    <component :is="pagemain" v-on="$listeners"></component>
</template>

<script>
    export default {
        name: 'index',
        computed: {
            pagemain: function () {
                this.$emit('showheaderfooter', true);
                this.$emit('hidepop');
                let folder = this.$route.params.root || 'home';
                folder = folder.toLowerCase();
                let filename = folder;

                let sub = this.$route.params.sub;
                if (!this.$common.basic.chempty(sub)) {
                    if ((sub != "0") && (this.$common.basic.chstr2int(sub) == 0)) {
                        filename = sub;
                    }
                }
                if (folder == "college") {
                    filename = folder;
                }
                return () => import('@/views/' + folder + '/' + filename);
            }
        }
    };
</script>
